"use client";

import { Button } from "@ui/components/core/Button";
import { useTranslations } from "next-intl";

interface InlineTermsProps {
  onAgree: () => void;
  onCancel: () => void;
}

export function InlineTerms({ onAgree, onCancel }: InlineTermsProps) {
  const t = useTranslations("ClientKeys.hero_video_agent");

  return (
    <div className='flex h-full w-full flex-col items-center justify-center p-24'>
      <div className='w-full max-w-[360px]'>
        <p className='f-paragraph-02 mb-16 text-center text-default'>{t("terms.intro")}</p>

        <ul className='mb-20 space-y-10'>
          <li className='f-paragraph-03 flex items-start gap-8 text-light'>
            <span className='mt-[5px] block h-4 w-4 flex-shrink-0 rounded-full bg-overlay-darker-plus' />
            <span className='text-xs'>{t("terms.age_requirement")}</span>
          </li>
          <li className='f-paragraph-03 flex items-start gap-8 text-light'>
            <span className='mt-[5px] block h-4 w-4 flex-shrink-0 rounded-full bg-overlay-darker-plus' />
            <span className='text-xs'>{t("terms.ai_acknowledgement")}</span>
          </li>
          <li className='f-paragraph-03 flex items-start gap-8 text-light'>
            <span className='mt-[5px] block h-4 w-4 flex-shrink-0 rounded-full bg-overlay-darker-plus' />
            <span className='text-xs'>{t("terms.recording_consent")}</span>
          </li>
          <li className='f-paragraph-03 flex items-start gap-8 text-light'>
            <span className='mt-[5px] block h-4 w-4 flex-shrink-0 rounded-full bg-overlay-darker-plus' />
            <span className='text-xs'>
              {t.rich("terms.privacy_policy", {
                link: chunks => (
                  <a
                    href='https://elevenlabs.io/privacy-policy'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-default underline underline-offset-2 hover:no-underline'
                  >
                    {chunks}
                  </a>
                ),
              })}
            </span>
          </li>
          <li className='f-paragraph-03 flex items-start gap-8 text-light'>
            <span className='mt-[5px] block h-4 w-4 flex-shrink-0 rounded-full bg-overlay-darker-plus' />
            <span className='text-xs'>{t("terms.data_sharing_consent")}</span>
          </li>
        </ul>

        <div className='flex gap-8'>
          <Button onClick={onAgree} variant='primary' size='md' className='flex-1'>
            {t("terms.agree_button")}
          </Button>
          <Button onClick={onCancel} variant='elevated' size='md' className='flex-1'>
            {t("terms.close")}
          </Button>
        </div>
      </div>
    </div>
  );
}
